import {
  SjIconRenderOptions,
  renderMoonIcon,
  renderSunIcon,
  renderSuperJsonIcon,
  renderPlusIcon,
  renderMinusIcon,
  renderXIcon,
  renderCheckIcon,
  renderEditIcon,
  renderTrashIcon,
  renderDownloadIcon,
  renderUploadIcon,
  renderRefreshIcon,
  renderExternalLinkIcon,
  renderLinkIcon,
  renderArrowLeftIcon,
  renderArrowRightIcon,
  renderArrowUpIcon,
  renderArrowDownIcon,
  renderChevronLeftIcon,
  renderChevronRightIcon,
  renderChevronUpIcon,
  renderChevronDownIcon,
  renderMenuIcon,
  renderSearchIcon,
  renderFilterIcon,
  renderListIcon,
  renderGridIcon,
  renderMoreHorizontalIcon,
  renderMoreVerticalIcon,
} from './main-icons';

export const SJ_ICON_RENDERERS = {
  sun: renderSunIcon,
  moon: renderMoonIcon,
  superJson: renderSuperJsonIcon,
  plus: renderPlusIcon,
  minus: renderMinusIcon,
  x: renderXIcon,
  check: renderCheckIcon,
  edit: renderEditIcon,
  trash: renderTrashIcon,
  download: renderDownloadIcon,
  upload: renderUploadIcon,
  refresh: renderRefreshIcon,
  externalLink: renderExternalLinkIcon,
  link: renderLinkIcon,
  arrowLeft: renderArrowLeftIcon,
  arrowRight: renderArrowRightIcon,
  arrowUp: renderArrowUpIcon,
  arrowDown: renderArrowDownIcon,
  chevronLeft: renderChevronLeftIcon,
  chevronRight: renderChevronRightIcon,
  chevronUp: renderChevronUpIcon,
  chevronDown: renderChevronDownIcon,
  menu: renderMenuIcon,
  search: renderSearchIcon,
  filter: renderFilterIcon,
  list: renderListIcon,
  grid: renderGridIcon,
  moreHorizontal: renderMoreHorizontalIcon,
  moreVertical: renderMoreVerticalIcon,
} as const;

export type SjIconName = keyof typeof SJ_ICON_RENDERERS;

export const icon = {
  sun: 'sun' as SjIconName,
  moon: 'moon' as SjIconName,
  superJson: 'superJson' as SjIconName,
  plus: 'plus' as SjIconName,
  minus: 'minus' as SjIconName,
  x: 'x' as SjIconName,
  check: 'check' as SjIconName,
  edit: 'edit' as SjIconName,
  trash: 'trash' as SjIconName,
  download: 'download' as SjIconName,
  upload: 'upload' as SjIconName,
  refresh: 'refresh' as SjIconName,
  externalLink: 'externalLink' as SjIconName,
  link: 'link' as SjIconName,
  arrowLeft: 'arrowLeft' as SjIconName,
  arrowRight: 'arrowRight' as SjIconName,
  arrowUp: 'arrowUp' as SjIconName,
  arrowDown: 'arrowDown' as SjIconName,
  chevronLeft: 'chevronLeft' as SjIconName,
  chevronRight: 'chevronRight' as SjIconName,
  chevronUp: 'chevronUp' as SjIconName,
  chevronDown: 'chevronDown' as SjIconName,
  menu: 'menu' as SjIconName,
  search: 'search' as SjIconName,
  filter: 'filter' as SjIconName,
  list: 'list' as SjIconName,
  grid: 'grid' as SjIconName,
  moreHorizontal: 'moreHorizontal' as SjIconName,
  moreVertical: 'moreVertical' as SjIconName,
};

export const SJ_ICON_SVGS = {
  sun: renderSunIcon(),
  moon: renderMoonIcon(),
  superJson: renderSuperJsonIcon(),
  plus: renderPlusIcon(),
  minus: renderMinusIcon(),
  x: renderXIcon(),
  check: renderCheckIcon(),
  edit: renderEditIcon(),
  trash: renderTrashIcon(),
  download: renderDownloadIcon(),
  upload: renderUploadIcon(),
  refresh: renderRefreshIcon(),
  externalLink: renderExternalLinkIcon(),
  link: renderLinkIcon(),
  arrowLeft: renderArrowLeftIcon(),
  arrowRight: renderArrowRightIcon(),
  arrowUp: renderArrowUpIcon(),
  arrowDown: renderArrowDownIcon(),
  chevronLeft: renderChevronLeftIcon(),
  chevronRight: renderChevronRightIcon(),
  chevronUp: renderChevronUpIcon(),
  chevronDown: renderChevronDownIcon(),
  menu: renderMenuIcon(),
  search: renderSearchIcon(),
  filter: renderFilterIcon(),
  list: renderListIcon(),
  grid: renderGridIcon(),
  moreHorizontal: renderMoreHorizontalIcon(),
  moreVertical: renderMoreVerticalIcon(),
} as const;

export type SjIconOptions = SjIconRenderOptions;

export const renderIcon = (name: SjIconName, options?: SjIconOptions): string =>
  SJ_ICON_RENDERERS[name](options);
